<table class="table__wrapper">
	<thead>
		<tr class="header__wrapper">
			<th class="header__text pl-8">
				<button
					class="flex flex-row items-center gap-2"
					(click)="toggleSort()">
					Id
					@if (sortDirection === 'desc') {
						<activar-icon name="arrow_down" size="15px" />
					} @else {
						<activar-icon name="arrow_up" size="15px" />
					}
				</button>
			</th>
			@if (showUser()) {
				<th class="header__text">Nombre</th>
			}

			<th class="header__text">Riesgo</th>
			@if (showProducer()) {
				<th class="header__text">Productor</th>
			}
			<th class="header__text text-center text-nowrap">Vigencia Hasta</th>
			<th class="header__text text-center">Estado</th>
			<th class="header__text px-8"></th>
		</tr>
	</thead>

	<tbody>
		@for (row of rows(); track row.id; let i = $index) {
			<tr
				class="body__wrapper"
				[ngClass]="i % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
				<td class="id__cell text-gray-600">
					{{ row.internalNumber }}
				</td>
				@if (showUser()) {
					<td>
						<activar-user-badge
							[firstName]="row.user.firstName"
							[lastName]="row.user.lastName"
							[email]="row.user.email"
							[companyName]="row.user.companyName" />
					</td>
				}

				<td [title]="row.risk.description">
					<div class="ellipsis">
						<activar-icon-title
							[icon]="getIconName(row.risk.tag)"
							[title]="row.risk.description" />
					</div>
				</td>
				@if (showProducer()) {
					<td class="">
						@if (isUserType(row.agent.type, USER_TYPES.COMPANY)) {
							{{ row.agent.companyName || '-' }}
						} @else {
							{{ row.agent.firstName || '-' }}
							{{ row.agent.lastName || '' }}
						}
					</td>
				}
				<td class="text-center">
					{{ row.expiresAt | date: 'd/M/yyyy' }}
				</td>
				<td>
					<activar-badge
						class="flex justify-center"
						[text]="row.badgeText"
						[status]="row.badgeStatus" />
				</td>
				<td class="text-center">
					<button
						(click)="openQuoteDetail(row)"
						class="text-primary-600 font-semibold">
						{{ row.action }}
					</button>
				</td>
			</tr>
		} @empty {
			<tr class="body__wrapper">
				<td class="my-5" colspan="7">
					<div
						class="flex flex-col items-center justify-center text-center w-full my-5">
						<div class="mb-8">
							No se encontraron cotizaciones para mostrar.
						</div>
						<img src="empty_list.svg" alt="empty" />
					</div>
				</td>
			</tr>
		}
	</tbody>
</table>
